import React from "react";
import ReactMarkdown, { type Components } from "react-markdown";
import { DRAWER_TEXT, NOTE_BLOCK } from "./drawer-type-roles";

const ALLOWED_ELEMENTS = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "p",
  "strong",
  "em",
  "ul",
  "ol",
  "li",
  "blockquote",
];

const TITLE = `${DRAWER_TEXT.recapTitle} mt-3`;
const HEADING = `${DRAWER_TEXT.sectionHeading} mt-9 [h1+&]:mt-7`;
const SUBHEADING = `${DRAWER_TEXT.subheading} mt-5`;
const BODY = `${DRAWER_TEXT.body} mt-3`;
const LIST = `${NOTE_BLOCK.list} ${NOTE_BLOCK.listItems}`;

const components: Components = {
  h1: ({ children }) => <h1 className={TITLE}>{children}</h1>,
  h2: ({ children }) => <h2 className={HEADING}>{children}</h2>,
  h3: ({ children }) => <h3 className={SUBHEADING}>{children}</h3>,
  h4: ({ children }) => <h4 className={SUBHEADING}>{children}</h4>,
  h5: ({ children }) => <h5 className={SUBHEADING}>{children}</h5>,
  h6: ({ children }) => <h6 className={SUBHEADING}>{children}</h6>,
  p: ({ children }) => <p className={BODY}>{children}</p>,
  strong: ({ children }) => <strong className="font-medium">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
  ul: ({ children }) => <ul className={`${LIST} list-disc`}>{children}</ul>,
  ol: ({ children, start }) => (
    <ol start={start} className={`${LIST} list-decimal`}>
      {children}
    </ol>
  ),
  li: ({ children }) => <li className="[&_p]:mt-0">{children}</li>,
  blockquote: ({ children }) => (
    <blockquote
      className={`${NOTE_BLOCK.quote} ${DRAWER_TEXT.quote} [&_p]:mt-0 [&_p]:text-muted-strong`}
    >
      {children}
    </blockquote>
  ),
};

/**
 * The Recap document, for both streamed partial text and the completed Recap.
 * Stricter than the prior-note renderer: no GFM, raw HTML skipped, and only
 * text-shaped elements survive, so links and images never become active.
 */
export function SessionRecapMarkdown({
  markdown,
}: {
  markdown: string;
}): React.ReactElement {
  return (
    <div className={`break-words ${DRAWER_TEXT.body}`}>
      <ReactMarkdown
        allowedElements={ALLOWED_ELEMENTS}
        unwrapDisallowed
        skipHtml
        components={components}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
